




import Vue from "vue";
import SearchTable from "@/components/common/SearchTable.vue";

export default Vue.extend({
  name: "EntitySearchTable",
  components: { SearchTable },
  props: {
    collection: {
      type: String,
      required: true,
    },
    loadOnMount: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: () => {
    return {
      loading: false,
      items: [] as any[],
    };
  },
  mounted() {
    if (this.loadOnMount) {
      this.loadItems();
    }
  },
  methods: {
    async loadItems() {
      this.loading = true;
      this.items = [];
      this.items = await this.$mongoService.searchDocuments(this.collection);
      this.loading = false;
    },
    async saveItem({ item }: any) {
      this.loading = true;
      if (item._id) {
        await this.$mongoService.updateDocument(
          this.collection,
          item._id,
          item
        );
      } else {
        await this.$mongoService.insertDocument(this.collection, item);
      }
      await this.loadItems();
      this.loading = false;
    },
    async deleteItem({ item }: any) {
      this.loading = true;
      if (item._id) {
        await this.$mongoService.deleteDocument(this.collection, item._id);
      } else {
        // nothing to delete...
      }
      await this.loadItems();
      this.loading = false;
    },
  },
});
